import { Component, OnInit } from "@angular/core";
import { RestricoesLgpdService } from "./restricoes-service/restricoes-lgpd.service";
import { FiltroService } from "./../../../../../src/app/shared/filtro/filtro.service";
import { ExportExcelService } from "./../../../../../src/app/shared/excel-service/export-excel.service";

@Component({
  selector: "app-restricoes-lgpd",
  templateUrl: "./restricoes-lgpd.component.html",
  styleUrls: ["./restricoes-lgpd.component.css"],
})
export class RestricoesLgpdComponent implements OnInit {
  cols: any[];
  rows: number = 10;
  dados: any;
  first: number = 0;
  NumCpf: any;
  Dealer: any;
  loading: boolean;
  dealers = [];
  display: any = false;
  dataFinal: Date;
  restricao: boolean = true;
  dataInicial: Date;
  paginaAtual: any = 1;
  displayRows: number = 0;
  tamanhoPagina: any = 10;
  totalRegistros: any = 0;

  constructor(private service: RestricoesLgpdService, 
    private servFiltro: FiltroService, 
    private exportExcelService: ExportExcelService) { }

  ngOnInit() {
    this.preencherDealers();
    const now = new Date();
    this.dataFinal = new Date();
    this.dataInicial = new Date(now.getFullYear(), now.getMonth(), 1);
    this.pesquisar();

    this.cols = [
      { field: "codDealer", header: "Codigo Dealer" },
      { field: "nomeDealer", header: "Dealer" },
      { field: "nomeCliente", header: "Nome" },
      { field: "numeroCpf", header: "CPF" },
      { field: "celular", header: "Celular" },
      { field: "telResidencial", header: "Tel. Residencial" },
      { field: "telComercial", header: "Tel. Comercial" },
      { field: "email", header: "E-mail" },
      { field: "contatoMkt", header: "Contato MKT" },
      { field: "aceitarEmail", header: "Aceita e-mail" },
      { field: "podeLigar", header: "Pode ligar" },
      { field: "smsWhatsApp", header: "SMS WhatsApp" },
      { field: "dataAtualizacao", header: "Data Atualização" },
    ];
  }

  buscar(page?: any) {
    let dtInicFormat = this.formatDateTime(this.dataInicial);
    let dtFimFormat = this.formatDateTime(this.dataFinal);
    this.loading = true;

    this.service.buscarServico("/restricao_lgpd", page, this.tamanhoPagina, dtInicFormat, dtFimFormat, this.Dealer, this.NumCpf, this.restricao).subscribe({
      next: (res) => {
        this.dados = res;
        if (this.dados.length > 0) {
          this.totalRegistros = res[0].totalRegistro;
        } else {
          this.totalRegistros = 0
        }
        this.loading = false
      },
      error: (erro) => {
        this.totalRegistros = 0;
        this.loading = false
      }
    })
  }

  pesquisar() {
    if (this.dataInicial != undefined) {
      this.paginaAtual = 1;
    } else {
      this.first = 0;
      this.paginaAtual = 1;
    }
    if (this.dataFinal != undefined) {
      this.paginaAtual = 1;
    } else {
      this.first = 0;
      this.paginaAtual = 1;
    }
    this.buscar(this.paginaAtual);
  }

  eventoPaginacao(event: any): void {
    this.paginaAtual = event.page + 1;
    this.tamanhoPagina = event.rows;
    this.displayRows = event.first;
    this.first = event.first;
    this.buscar(this.paginaAtual);
  }

  exibirFiltro() {
    this.display = true;
  }

  preencherDealers() {
    this.servFiltro.buscar('dealer')
      .then(r => { this.dealers = r.filtros; });
  }

  formatDateTime(value: any): string {
    let pad: Function = (val: number) => {
      return val < 10 ? '0' + val : val;
    };
    return value.getFullYear() + '-' + pad(value.getMonth() + 1) + '-' + pad(value.getDate())
      + 'T' + pad(value.getHours()) + ':' + pad(value.getMinutes()) + ':' + pad(value.getSeconds());
  }

  limparFiltros() {
    this.NumCpf = '';
    this.Dealer = '';
    const checked = document.getElementById('switch');
    (checked as HTMLInputElement).checked = true;
  }

  filtroAPI() {
    const checked = document.getElementById('switch');
    this.restricao = (checked as HTMLInputElement).checked;
    this.pesquisar();
    this.display = false;
  }

  protected translateField(item) {
    return item;
  }

  protected translateHeader(item) {
    if (item == "Codigo Dealer") {
      return "Codigo Dealer";
    }
    if (item == "Dealer") {
      return "Dealers";
    }
    if (item == "Nome") {
      return "Nome";
    }
    if (item == "CPF") {
      return "CPF";
    }
    if (item == "Celular") {
      return "Celular";
    }
    if (item == "Tel. Residencial") {
      return "Tel. Residencial";
    }
    if (item == "Tel. Comercial") {
      return "Tel. Comercial";
    }
    if (item == "E-mail") {
      return "E-mail";
    }
    if (item == "Contato MKT") {
      return "Contato MKT";
    }
    if (item == "Aceita e-mail") {
      return "Aceita e-mail";
    }
    if (item == "Pode ligar") {
      return "Pode ligar";
    }
    if (item == "SMS WhatsApp") {
      return "SMS WhatsApp";
    }
    if (item == "Data Atualização") {
      return "Data Atualização";
    }
  }

  exportExcel() {
    let registros = [];
    let dtInicFormat = this.formatDateTime(this.dataInicial);
    let dtFimFormat = this.formatDateTime(this.dataFinal);

    this.service.buscarServico("/restricao_lgpd", this.paginaAtual, this.tamanhoPagina, dtInicFormat, dtFimFormat, this.Dealer, this.NumCpf, this.restricao).subscribe({
      next: (res) => {
        registros = res;

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = "Restrição LGPD";
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this.cols.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      }
    });
  }
}
